import { CancelToken } from 'axios';
import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODCreateResponse, IVODRequestParams } from '~/Models/DTO/VideoOnDemand.models';

export const useRequestCreateVOD = (cancelToken?: CancelToken) => {
  const { currentProvider } = useProvider();

  const {
    data: vodCreateResponse,
    error: vodCreateError,
    isLoading: isVodVideoCreateLoading,
    mutate: createVideo,
    isSuccess: isVodVideoCreateSuccess,
  } = useMutation<IVODCreateResponse, IErrorResponse, IVODRequestParams>(
    async (params: IVODRequestParams) =>
      requestReactQuery<IVODCreateResponse>({
        url: VIDEO_INTEGRATION_SERVICE_URLS.VOD_VIDEOS,
        data: {
          ...params,
          state: undefined,
          organisationId: currentProvider?.organisationId,
          providerId: currentProvider?.uuid,
          forwardToBookingTool: false,
          forwardToUSC: true,
          releaseDate: params?.state === 'online' ? new Date().toISOString() : null,
        },
        config: { method: 'POST', cancelToken },
      }),
    { mutationKey: REQUEST_ACTIONS.ACTIVATE_VOD },
  );

  return {
    vodCreateError: vodCreateError as IErrorResponse,
    vodCreateResponse,
    createVideo,
    isVodVideoCreateLoading,
    isVodVideoCreateSuccess,
  };
};
